module.exports = __webpack_public_path__ + "static/lightning-datepicker-range-a5b83306c0d32679bb4ee85b863d6fcc.png";